/* ═══════════════════════════════════════════════════
   TrackLab v2 — Bet Panel
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.betting = {};

  // Read bookmaker URLs and brand colours from server-injected JSON (bookmaker_config collection)
  var BOOKMAKER_URLS = (function () {
    var el = document.getElementById('bookmakerUrls');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) { /* fall through */ } }
    return {};
  })();

  var BOOKMAKER_COLORS = (function () {
    var el = document.getElementById('bookmakerColors');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) { /* fall through */ } }
    return {};
  })();

  TL.betting.getBookmakerUrl = function (name) {
    return BOOKMAKER_URLS[name] || BOOKMAKER_URLS[name.trim()] || '';
  };

  TL.betting.getBookmakerColor = function (name) {
    return BOOKMAKER_COLORS[name] || BOOKMAKER_COLORS[name.trim()] || '';
  };

  // Display-only label; data strings stay "1/1" (parsed by split('/')).
  TL.betting._oddsLabel = function (frac) { return frac === '1/1' ? 'Evens' : (frac || ''); };

  TL.betting._confidenceTier = function (score) {
    return TL.scoreTier(score).label;
  };

  TL.betting._fmtMoney = function (x) {
    return x.toFixed(2).replace(/\.00$/, '');
  };

  // Integer pence -> "62p" under \u00A31, otherwise "\u00A32.50" (".00" dropped).
  TL.betting.fmtPence = function (cents) {
    if (cents < 100) return cents + 'p';
    var pp = cents % 100;
    return '\u00A3' + Math.floor(cents / 100) + (pp ? '.' + (pp < 10 ? '0' : '') + pp : '');
  };

  // Money with the pence rule: under \u00A31 -> "62p" (nearest penny); otherwise
  // "\u00A32.50", with ".00" dropped ("\u00A33").
  TL.betting.fmtMoneyP = function (x) {
    return TL.betting.fmtPence(Math.round(x * 100));
  };

  // Round n/d to the nearest integer, half up (integer maths, no float error).
  TL.betting._rhu = function (n, d) {
    return Math.floor((2 * n + d) / (2 * d));
  };

  // Win bet in integer pence (stake is whole pounds): back = stake + stake * num/den.
  TL.betting.winCalc = function (num, den, stake) {
    var P = Math.round(stake * 100);
    var profit = TL.betting._rhu(P * num, den);
    return { stakePence: P, profitPence: profit, totalPence: P + profit };
  };

  // Profit-size label only; the score % is shown once elsewhere.
  // isValue (the runner's "Underrated horse" box shows) drops ", but less likely".
  TL.betting.sizeLabel = function (num, den, score, isValue) {
    var r = num / den;
    var label = r < 1 ? 'Small profit if it wins'
      : (r <= 3 ? 'Moderate profit if it wins'
        : 'Bigger profit if it wins' + (isValue ? '' : ', but less likely'));
    return label;
  };

  // "Less" line under a runner's odds. Mirrors services.less_line:
  // "£1 wins 62p · 28 Strong chance" (no profit-size label). '' for invalid odds.
  // A 4th arg (legacy isValue) is accepted and ignored.
  TL.betting.lessLine = function (num, den, score, isValue) {
    num = Number(num);
    den = Number(den);
    if (!(den > 0) || !(num >= 0)) return '';
    // Integer half-up pence, same as services.less_line (no float error).
    var cents = Math.floor((num * 200 + den) / (2 * den));
    var money;
    if (cents < 100) {
      money = cents + 'p';
    } else {
      var pounds = Math.floor(cents / 100);
      var pp = cents % 100;
      money = '£' + pounds + (pp ? '.' + (pp < 10 ? '0' : '') + pp : '');
    }
    var chance = TL.scoreChance(score);
    return '£1 wins ' + money + (chance ? ' · ' + chance : '');
  };

  // Render the Less line into `el` with "28 Strong chance" in a banded span
  // (same markup as the server's less_line_html). DOM nodes only, no innerHTML.
  TL.betting.renderLessLine = function (el, num, den, score, isValue) {
    var text = TL.betting.lessLine(num, den, score, isValue);
    el.textContent = '';
    var chance = TL.scoreChance(score);
    var at = chance ? text.indexOf(chance) : -1;
    if (at < 0) {
      el.appendChild(document.createTextNode(text));
      return;
    }
    var span = document.createElement('span');
    span.className = TL.scoreTierClass(score);
    span.setAttribute('data-score', String(score));
    span.textContent = chance;
    el.appendChild(document.createTextNode(text.slice(0, at)));
    el.appendChild(span);
    el.appendChild(document.createTextNode(text.slice(at + chance.length)));
  };

  // The race's each-way terms, parsed once for both the panel's words and its
  // maths. They come from the race root's data-ew-places / data-ew-fraction
  // (race.ew_terms, built by services._extract_ew_terms from the bookmaker
  // odds' ew_places and ew_denom). Returns {places: 4, fn: 1, fd: 4,
  // fraction: '1/4'}, or null when the race has no usable terms: win only,
  // unknown, fewer than 2 places, or a bad fraction. Never a default number.
  TL.betting.ewTerms = function (places, fraction) {
    var pm = /^(\d+)(?:\.0+)?$/.exec(String(places == null ? '' : places).trim());
    var m = /^\s*(\d+)\s*\/\s*(\d+)\s*$/.exec(String(fraction == null ? '' : fraction));
    if (!pm || !m) return null;
    var n = parseInt(pm[1], 10);
    var fn = parseInt(m[1], 10);
    var fd = parseInt(m[2], 10);
    if (n < 2 || !(fn > 0) || !(fd > 0)) return null;
    return { places: n, fn: fn, fd: fd, fraction: fn + '/' + fd };
  };

  // How the panel names the second bet of an each-way bet: "in the top 4" from
  // the race's own terms, or "near the front" when there are none (no number
  // is made up).
  TL.betting.ewWhere = function (terms) {
    return terms ? 'in the top ' + terms.places : 'near the front';
  };

  // Each Way maths. `stake` is the amount on EACH part (win and place), so the
  // total cost is double. fraction is "1/N" (place fraction fn/fd of the odds
  // r = num/den).
  //   win part return   = stake * (r + 1)
  //   place part return = stake * (r * f + 1)
  //   total if wins     = win part + place part;  total if places = place part
  // Each figure is rounded once, half up, to the penny, in integer pence (so JS
  // and Python agree); the total if wins is one rounding of the exact sum.
  // Returns null when the race has no usable each-way terms (see ewTerms), so
  // the maths and the words always come from the same places and fraction.
  TL.betting.ewCalc = function (num, den, stake, places, fraction) {
    var t = TL.betting.ewTerms(places, fraction);
    if (!t) return null;
    var fn = t.fn;
    var fd = t.fd;
    var P = Math.round(stake * 100);
    var rhu = TL.betting._rhu;
    var d = den * fd;
    var costPence = 2 * P;
    var winPence = rhu(P * (num + den) * fd, d);
    var placePence = rhu(P * (num * fn + den * fd), d);
    var winsPence = rhu(P * ((num + den) * fd + num * fn + den * fd), d);
    return {
      places: t.places,
      fraction: t.fraction,
      cost: 2 * stake,
      costPence: costPence,
      stakePence: P,
      winPence: winPence,
      placePence: placePence,
      totalIfWinsPence: winsPence,
      winReturn: winPence / 100,
      placeReturn: placePence / 100,
      totalIfWins: winsPence / 100,
      totalIfPlaces: placePence / 100,
      shortOddsNote: placePence < costPence,
    };
  };

  // The non-winning finishing positions an each-way bet pays on, from the
  // bookmaker's places count: 2 -> "2nd", 3 -> "2nd or 3rd",
  // 4 -> "2nd, 3rd or 4th". "" when the count is missing, invalid or < 2.
  // Mirrors services.ew_paid_positions (parity cases in both test suites).
  TL.betting._ordinal = function (n) {
    var mod100 = n % 100;
    var suffix = 'th';
    if (mod100 < 11 || mod100 > 13) {
      suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th';
    }
    return n + suffix;
  };

  TL.betting.ewPositions = function (places) {
    var s = String(places == null ? '' : places).trim();
    if (!/^\d+$/.test(s)) return '';
    var n = parseInt(s, 10);
    if (n < 2) return '';
    var out = [];
    for (var i = 2; i <= n; i++) out.push(TL.betting._ordinal(i));
    if (out.length === 1) return out[0];
    return out.slice(0, -1).join(', ') + ' or ' + out[out.length - 1];
  };

  // "£1 each way costs £2: £1 to win, £1 on finishing in the top 4." Needs no
  // odds. `terms` is ewTerms(...) for the race, or null.
  TL.betting.ewExample = function (stake, terms) {
    var f = TL.betting.fmtMoneyP;
    return f(stake) + ' each way costs ' + f(2 * stake) + ': ' + f(stake) + ' to win, ' +
      f(stake) + ' on finishing ' + TL.betting.ewWhere(terms) + '.';
  };

  // "In this race, the second bet pays if your horse finishes in the top 4, at
  // 1/4 of the win odds." Only when the race has terms.
  TL.betting.ewTermsLine = function (terms) {
    if (!terms) return '';
    return 'In this race, the second bet pays if your horse finishes ' + TL.betting.ewWhere(terms) +
      ', at ' + terms.fraction + ' of the win odds. Your bookmaker\'s terms can differ, so check the slip.';
  };

  TL.betting._updateReturn = function () {
    var st = TL.state;
    var stake = st.betAmt;
    var isEw = st.betType === 'ew';
    var terms = TL.betting.ewTerms(st.ewPlaces, st.ewFraction);
    var where = TL.betting.ewWhere(terms);
    var calc = isEw ? TL.betting.ewCalc(st.betNum, st.betDen, stake, st.ewPlaces, st.ewFraction) : null;
    var f = TL.betting.fmtMoneyP;
    var fp = TL.betting.fmtPence;

    var el = function (id) { return document.getElementById(id); };
    var setText = function (id, text) { var n = el(id); if (n) n.textContent = text; };

    setText('v2bpBetLabel', 'Your bet');
    if (isEw) {
      setText('v2bpProfitLabel', 'If your horse wins: total back');
      setText('v2bpTotalLabel', 'If it finishes ' + where + " but doesn't win: total back");
      setText('v2bpBet', f(2 * stake) + ' (' + f(stake) + ' to win + ' + f(stake) + ' on finishing ' + where + ')');
      setText('v2bpProfit', calc ? fp(calc.totalIfWinsPence) : '\u2014');
      setText('v2bpTotal', calc ? fp(calc.placePence) : '\u2014');
    } else {
      var w = TL.betting.winCalc(st.betNum, st.betDen, stake);
      setText('v2bpProfitLabel', 'Your profit if your horse wins');
      setText('v2bpTotalLabel', 'Total back to you');
      setText('v2bpBet', fp(w.stakePence));
      setText('v2bpProfit', fp(w.profitPence));
      setText('v2bpTotal', fp(w.totalPence));
    }

    var hasOdds = st.betNum > 0;
    var szEl = el('v2bpSize');
    if (szEl) {
      szEl.hidden = !hasOdds;
      szEl.textContent = hasOdds ? TL.betting.sizeLabel(st.betNum, st.betDen, st.betScore) : '';
    }

    var ewEl = el('v2bpEw');
    if (ewEl) {
      ewEl.hidden = !isEw;
      var introEl = el('v2bpEwIntro');
      var termsEl = el('v2bpEwTerms');
      var workedEl = el('v2bpEwExample');
      var shortEl = el('v2bpEwShort');
      var missEl = el('v2bpEwMissing');
      var showMaths = !!calc && hasOdds;
      if (introEl) {
        introEl.textContent = 'Each way is two equal bets, so it costs double: one on your horse to win, ' +
          'and one on it to finish ' + where + '.';
      }
      if (termsEl) {
        termsEl.hidden = !terms;
        termsEl.textContent = TL.betting.ewTermsLine(terms);
      }
      if (workedEl) workedEl.textContent = TL.betting.ewExample(stake, terms);
      if (shortEl) {
        shortEl.hidden = !(showMaths && calc.shortOddsNote);
        shortEl.textContent = showMaths
          ? 'The odds are short. If your horse finishes ' + where + " but doesn't win, you could get back less than the " +
            f(2 * stake) + ' you bet.'
          : '';
      }
      if (missEl) missEl.hidden = !!terms;
    }
  };

  var _bookieSlug = function (name) {
    return name.toLowerCase().replace(/[^a-z0-9]/g, '-');
  };

  var _span = function (cls, text) {
    var el = document.createElement('span');
    el.className = cls;
    if (text) el.textContent = text;
    return el;
  };

  // Parsed compare rows for a runner element: inline data-all-bookmakers first,
  // then the per-race cache. Returns [] when nothing usable is available.
  TL.betting._rowsFor = function (el, raceId) {
    var inline = el && el.dataset && el.dataset.allBookmakers;
    if (inline) {
      try {
        var parsed = JSON.parse(inline);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) { /* fall through */ }
    }
    var cache = TL.runner && TL.runner._bookmakerCache;
    var byHorse = cache && cache[raceId];
    var rows = byHorse && byHorse[el && el.dataset ? el.dataset.horse : ''];
    return Array.isArray(rows) ? rows : [];
  };

  // The ONE selection function: which bookmaker/odds/url does the bet button offer?
  // rows[0] is the server's bet-button bookmaker when rows exist.
  TL.betting.offerFor = function (el, rows) {
    var d = (el && el.dataset) || {};
    if (Array.isArray(rows) && rows.length) {
      var r = rows[0];
      return {
        bookie: r.name || '',
        displayName: r.display_name || r.name || '',
        odds: r.fractional || '',
        url: r.url || '',
        deeplink: !!r.deeplink,
        rows: rows,
      };
    }
    var bookie = d.bestBookmaker || '';
    var url = d.bestUrl || (bookie ? TL.betting.getBookmakerUrl(bookie) : '');
    return {
      bookie: bookie,
      displayName: d.bestDisplayName || bookie,
      odds: d.bestOdds || d.odds || '',
      url: url,
      deeplink: d.bestDeeplink === '1',
      rows: [],
    };
  };

  // Honest link labels: say so when the link does not pre-select the horse.
  TL.betting.linkLabels = function (o) {
    if (o.deeplink) {
      return {
        aria: 'Bet on ' + o.horse + ' at ' + o.odds + ' with ' + o.displayName + ', opens in a new tab',
        sub: '',
      };
    }
    return {
      aria: o.displayName + ' horse racing, opens in a new tab. ' + o.horse + ' is not pre-selected',
      sub: o.displayName + ' horse racing',
    };
  };

  // Each Way bet-slip help, named after the bookmaker the button links to.
  TL.betting.ewHelpText = function (displayName) {
    var name = String(displayName || '').trim();
    if (!name) return "On your bookmaker's bet slip, tick 'Each Way' before you place the bet.";
    return 'On ' + name + ", tick the 'Each Way' box on your bet slip before you place the bet.";
  };

  // Render the panel anchor (text, href, class, aria, sub-label) from an offer.
  // Also used by odds polling and the bookmaker picker, so the E/W help follows the button.
  TL.betting._renderPanelButton = function (offer, horse) {
    var helpEl = document.getElementById('v2bpEwHelp');
    if (helpEl) helpEl.textContent = TL.betting.ewHelpText(offer.displayName || offer.bookie);
    var panelBtn = document.getElementById('v2bpBetBtn') || document.querySelector('.v2bp-place-bet');
    if (!panelBtn) return;
    // "Bet with William Hill 9/4": the name may truncate, the odds never do.
    var name = offer.displayName || offer.bookie;
    var odds = TL.betting._oddsLabel(offer.odds);
    panelBtn.textContent = '';
    panelBtn.appendChild(_span('v2bp-bet-label', name ? ('Bet with ' + name) : 'Bet'));
    if (name && odds) {
      panelBtn.appendChild(document.createTextNode(' '));
      panelBtn.appendChild(_span('v2bp-bet-odds', odds));
    }
    panelBtn.className = 'v2bp-place-bet bookie-' + _bookieSlug(offer.bookie || '');
    // No URL, no href: a disabled button never opens a blank tab.
    if (offer.url) {
      panelBtn.href = offer.url;
      panelBtn.target = '_blank';
      panelBtn.rel = 'sponsored noopener noreferrer';
      panelBtn.removeAttribute('aria-disabled');
    } else {
      panelBtn.removeAttribute('href');
      panelBtn.setAttribute('aria-disabled', 'true');
      panelBtn.className += ' is-disabled';
    }
    TL.betting._applyLinkLabels(panelBtn, offer, horse);
  };

  TL.betting._applyLinkLabels = function (panelBtn, offer, horse) {
    var labels = TL.betting.linkLabels({
      displayName: offer.displayName || offer.bookie,
      horse: horse,
      odds: TL.betting._oddsLabel(offer.odds),
      deeplink: !!offer.deeplink,
    });
    panelBtn.setAttribute('aria-label', labels.aria);
    var sub = document.getElementById('v2bpBetSub');
    if (!sub) {
      sub = document.createElement('span');
      sub.className = 'v2bp-link-sub';
      sub.id = 'v2bpBetSub';
      panelBtn.insertAdjacentElement('afterend', sub);
    }
    sub.textContent = labels.sub;
    sub.hidden = !labels.sub;
  };

  // "Odds changed from X to Y" inside the bet box. change = {from, to} or null to clear.
  TL.betting._showOddsNote = function (change) {
    var note = document.getElementById('v2bpOddsNote');
    if (!note) return;
    if (!change) {
      note.hidden = true;
      note.textContent = '';
      note.removeAttribute('title');
      return;
    }
    var text = 'Odds changed from ' + TL.betting._oddsLabel(change.from) +
      ' to ' + TL.betting._oddsLabel(change.to);
    note.textContent = text;
    note.title = text;
    note.hidden = false;
  };

  // Polling tells us when a runner's odds move; update the box if it is open on that runner.
  document.addEventListener('tl:odds-changed', function (e) {
    var panel = document.getElementById('v2BetPanel');
    var horseEl = document.getElementById('v2bpHorse');
    var d = e.detail || {};
    if (!panel || !panel.classList.contains('open') || !horseEl) return;
    if (horseEl.textContent !== d.horse) return;
    TL.betting._showOddsNote(d);
  });

  // Race id for a runner element: its nearest [data-race-id] (race page and race
  // lists), else the race open in the races view.
  TL.betting._raceIdFor = function (el) {
    var host = el && el.closest ? el.closest('[data-race-id]') : null;
    return (host && host.dataset.raceId) || TL.state.activeRaceId || '';
  };

  var _sameBookie = function (a, b) { return _bookieSlug(a || '') === _bookieSlug(b || ''); };

  // Show one offer in the panel: the odds and the Bet link (money lines via _updateReturn).
  TL.betting._showOffer = function (offer, horse) {
    var oddsParts = String(offer.odds || '').split('/');
    TL.state.betNum = parseInt(oddsParts[0]) || 0;
    TL.state.betDen = parseInt(oddsParts[1]) || 1;
    var oddsEl = document.getElementById('v2bpOdds');
    if (oddsEl) oddsEl.textContent = TL.betting._oddsLabel(offer.odds);
    TL.betting._renderPanelButton(offer, horse);
  };

  // Mark the bookmaker the Bet button currently uses in the ▼ list.
  TL.betting._markSelected = function (name) {
    var list = document.getElementById('v2bpBookieList');
    if (!list) return;
    list.querySelectorAll('.v2bp-bookie-row').forEach(function (r) {
      var on = _sameBookie(r.dataset.bookie, name);
      r.classList.toggle('selected', on);
      r.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  // The user picked a bookmaker: the odds, the money lines and the Bet link follow it; the list closes.
  TL.betting._selectBookie = function (bk) {
    TL.state.bookiePicked = true;
    var horseNode = document.getElementById('v2bpHorse');
    TL.betting._showOffer({
      bookie: bk.name, displayName: bk.display_name || bk.name, odds: bk.fractional,
      url: bk.url, deeplink: !!bk.deeplink,
    }, horseNode ? horseNode.textContent : '');
    TL.betting._updateReturn();
    TL.betting._markSelected(bk.name);
    TL.betting._setBookieListOpen(false);
  };

  // Open or close the bookmaker list under the split button.
  TL.betting._setBookieListOpen = function (open) {
    var listEl = document.getElementById('v2bpBookieList');
    var toggle = document.getElementById('v2bpBookieToggle');
    var split = document.getElementById('v2bpBetSplit');
    if (listEl) listEl.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (split) split.classList.toggle('open', !!open);
  };

  TL.betting._bookieListOpen = function () {
    var listEl = document.getElementById('v2bpBookieList');
    return !!listEl && !listEl.hidden;
  };

  // Split button "Bet with X | ▼": the ▼ lists every bookmaker with a link.
  // The ▼ is hidden (plain full-width button) when fewer than two have a link.
  TL.betting._renderBookieList = function (rows, chosen) {
    var listEl = document.getElementById('v2bpBookieList');
    var toggle = document.getElementById('v2bpBookieToggle');
    var split = document.getElementById('v2bpBetSplit');
    if (!listEl) return;
    var linked = (Array.isArray(rows) ? rows : []).filter(function (bk) { return bk && bk.url; });
    listEl.textContent = '';
    TL.betting._setBookieListOpen(false);
    var hasChoice = linked.length >= 2;
    if (toggle) {
      toggle.hidden = !hasChoice;
      toggle.disabled = false;
      toggle.classList.remove('tl-skel-toggle');
      delete toggle.dataset.loading;
    }
    if (split) split.classList.toggle('has-choice', hasChoice);
    if (!hasChoice) return;

    var best = linked.reduce(function (a, b) { return Number(b.decimal) > Number(a.decimal) ? b : a; });
    linked.forEach(function (bk) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'v2bp-bookie-row';
      row.dataset.bookie = bk.name;
      var pip = _span('v2bp-bookie-pip');
      if (bk.brand_color) pip.style.background = bk.brand_color;
      row.appendChild(pip);
      row.appendChild(_span('v2bp-bookie-name', bk.display_name || bk.name));
      if (bk === best) row.appendChild(_span('v2bp-bookie-best', 'Best odds'));
      row.appendChild(_span('v2bp-bookie-odds', TL.betting._oddsLabel(bk.fractional)));
      row.addEventListener('click', function () { TL.betting._selectBookie(bk); });
      listEl.appendChild(row);
    });
    TL.betting._markSelected(chosen);
  };

  // team#129: while the ▼ list loads, the ▼ waits disabled in its own slot,
  // the same split as when it's loaded (has-choice), so the Bet button and
  // its label don't move when 2+ bookmakers arrive. The list stays closed.
  TL.betting._holdBookieToggle = function (token) {
    var toggle = document.getElementById('v2bpBookieToggle');
    var split = document.getElementById('v2bpBetSplit');
    if (!toggle) return;
    toggle.dataset.loading = String(token);
    toggle.hidden = false;
    toggle.disabled = true;
    if (split) split.classList.add('has-choice');
  };

  // Still loading after 150ms: the waiting ▼ dims with a shimmer
  // (skeleton.css). Returns it (the loader's "skeleton"), or null when a
  // newer panel owns the ▼.
  TL.betting._showBookieLoading = function (token) {
    var toggle = document.getElementById('v2bpBookieToggle');
    if (!toggle || toggle.dataset.loading !== String(token)) return null;
    toggle.classList.add('tl-skel-toggle');
    return toggle;
  };

  // Done waiting: back to today's state (▼ hidden) unless a newer panel
  // owns the ▼. Rows that arrive then set the ▼ up (_renderBookieList).
  TL.betting._releaseBookieToggle = function (token) {
    var toggle = document.getElementById('v2bpBookieToggle');
    var split = document.getElementById('v2bpBetSplit');
    if (!toggle || toggle.dataset.loading !== String(token)) return;
    delete toggle.dataset.loading;
    toggle.classList.remove('tl-skel-toggle');
    toggle.disabled = false;
    toggle.hidden = true;
    if (split) split.classList.remove('has-choice');
  };

  TL.betting.openPanel = function (sourceEl) {
    var sel = sourceEl || null;
    if (!sel && TL.state.activeRaceId) {
      sel = document.querySelector('#v2Expanded-' + TL.state.activeRaceId + ' .runner.sel')
         || document.querySelector('#v2InlineDetail-' + TL.state.activeRaceId + ' .runner.sel');
    }
    if (!sel) return;

    var horse = sel.dataset.horse || '';
    var score = Number(sel.dataset.score) || 0;
    var raceId = TL.betting._raceIdFor(sel);
    var offer = TL.betting.offerFor(sel, TL.betting._rowsFor(sel, raceId));

    TL.state.bestBookmaker = offer.bookie;
    TL.state.bookiePicked = false;

    var horseEl = document.getElementById('v2bpHorse');
    var scoreEl = document.getElementById('v2bpScore');
    var tierEl = document.getElementById('v2bpTier');

    if (horseEl) horseEl.textContent = horse;
    if (scoreEl) {
      scoreEl.textContent = TL.scorePct(score);
      ['top', 'great', 'good', 'mid', 'low'].forEach(function (t) { scoreEl.classList.remove('s-' + t); });
      scoreEl.classList.add(TL.scoreTierClass(score));
      scoreEl.setAttribute('data-score', String(score));
    }
    if (tierEl) tierEl.textContent = TL.betting._confidenceTier(score);

    // Odds moved since the page loaded? Say so (latest change for this runner).
    var seen = TL.state.oddsChanges
      && TL.state.oddsChanges[raceId + '|' + horse];
    TL.betting._showOddsNote(seen || null);

    // Default Bet button: the offer (best price; the default bookmaker when that is an exchange).
    TL.betting._showOffer(offer, horse);

    // The ▼ list: rows already on the page, else fetched once per race.
    // Fetched rows also give the default offer (rows[0]) unless the user has picked.
    var token = TL.state.panelToken = (TL.state.panelToken || 0) + 1;
    TL.betting._renderBookieList(offer.rows, offer.bookie);
    if (!offer.rows.length && raceId && TL.runner && TL.runner._resolveBookmakers) {
      var applyRows = function (rows) {
        if (token !== TL.state.panelToken || !rows.length) return;
        var fresh = TL.betting.offerFor(sel, rows);
        if (!TL.state.bookiePicked) {
          TL.betting._showOffer(fresh, horse);
          TL.betting._updateReturn();
        }
        TL.betting._renderBookieList(rows, fresh.bookie);
      };
      var request = new Promise(function (resolve) {
        TL.runner._resolveBookmakers(sel, raceId, horse, resolve);
      });
      if (TL.skeleton && TL.skeleton.load) {
        // team#129: the ▼ waits disabled in its slot from the start; a fetch
        // over 150ms dims it with a shimmer. The list stays closed. Then the
        // rows (or today's state) as before.
        TL.betting._holdBookieToggle(token);
        TL.skeleton.load(request, {
          show: function () { return TL.betting._showBookieLoading(token); },
          busy: document.getElementById('v2BetPanel'),
          label: 'Loading bookmakers',
        }).then(function (r) {
          TL.betting._releaseBookieToggle(token);
          applyRows(r.value);
        }, function () {
          // 8s: back to today's state; a late answer still fills the list.
          TL.betting._releaseBookieToggle(token);
          request.then(applyRows);
        });
      } else {
        request.then(applyRows);
      }
    }

    // Reset stake to £1 and bet type to Win
    TL.state.betAmt = 1;
    document.querySelectorAll('.v2bp-amt:not(.v2bp-type)').forEach(function (b) {
      b.classList.toggle('sel', /\(this,\s*1\)/.test(b.getAttribute('onclick') || ''));
    });
    TL.state.betType = 'win';
    document.querySelectorAll('.v2bp-type').forEach(function (b) {
      b.classList.toggle('sel', b.dataset.type === 'win');
    });
    TL.state.betScore = sel.dataset.score;

    // Race each-way terms, exposed by the race card / race page root
    var ewRoot = sel.closest ? sel.closest('[data-ew-places]') : null;
    TL.state.ewPlaces = ewRoot ? ewRoot.dataset.ewPlaces : null;
    TL.state.ewFraction = ewRoot ? ewRoot.dataset.ewFraction : null;

    TL.betting._updateReturn();

    var panel = document.getElementById('v2BetPanel');
    if (panel) {
      // Opened again on another runner: keep the first opener's lock count right
      if (TL.betting._releasePanel) { TL.betting._releasePanel(false); TL.betting._releasePanel = null; }
      panel.scrollTop = 0;
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bet-panel-open');
      // Phones: a dim backdrop behind the sheet; a tap on it closes the sheet (team#160)
      var scrim = document.querySelector('.v2bp-scrim');
      if (!scrim && window.matchMedia && window.matchMedia('(max-width: 700px)').matches) {
        scrim = document.createElement('div');
        scrim.className = 'v2bp-scrim';
        scrim.addEventListener('click', function () { TL.betting.closePanel(); });
        panel.parentNode.insertBefore(scrim, panel);
      }
      // A dialog (team#159 helper): focus inside, Tab stays in, focus back to the Bet button on close.
      // Esc is handled below (after the bookmaker list's own Esc).
      if (window.TLSheet) {
        // The Bet button just tapped (Safari doesn't focus buttons on tap), else whatever has focus
        var opener = TL.betting._lastBetBtn || (document.activeElement !== document.body ? document.activeElement : null);
        TL.betting._lastBetBtn = null;
        TL.betting._releasePanel = window.TLSheet.openSheet(panel, { label: 'Your pick', opener: opener, scrim: scrim });
      }
    }
  };

  TL.betting.closePanel = function () {
    var panel = document.getElementById('v2BetPanel');
    // Focus goes back to the Bet button before the panel is hidden from screen readers
    if (TL.betting._releasePanel) { var release = TL.betting._releasePanel; TL.betting._releasePanel = null; release(); }
    var scrim = document.querySelector('.v2bp-scrim');
    if (scrim) scrim.remove();
    if (panel) {
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('bet-panel-open');
  };

  // team#37: the panel starts closed; only a Bet tap opens it.
  TL.betting.initPanel = function () { TL.betting.closePanel(); };

  // ▼ toggles the bookmaker list; Escape inside the panel closes an open list
  // (and stops there, so the panel stays open).
  TL.betting._bindBookieToggle = function () {
    var toggle = document.getElementById('v2bpBookieToggle');
    var panel = document.getElementById('v2BetPanel');
    if (toggle) {
      toggle.addEventListener('click', function () {
        TL.betting._setBookieListOpen(!TL.betting._bookieListOpen());
      });
    }
    if (panel) {
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !TL.betting._bookieListOpen()) return;
        e.stopPropagation();
        TL.betting._setBookieListOpen(false);
        if (toggle) toggle.focus();
      });
    }
  };

  var _onReady = function () { TL.betting.initPanel(); TL.betting._bindBookieToggle(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _onReady);
  } else {
    _onReady();
  }

  TL.betting.pickAmt = function (btn, amt) {
    document.querySelectorAll('.v2bp-amt:not(.v2bp-type)').forEach(function (b) { b.classList.remove('sel'); });
    btn.classList.add('sel');
    TL.state.betAmt = amt;
    TL.betting._updateReturn();
  };

  TL.betting.pickType = function (btn, type) {
    document.querySelectorAll('.v2bp-type').forEach(function (b) { b.classList.remove('sel'); });
    btn.classList.add('sel');
    TL.state.betType = type === 'ew' ? 'ew' : 'win';
    TL.betting._updateReturn();
  };

  // Remember which Bet button opened the panel, so closing it can return focus there
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="bet"], [data-slot="bet-btn"]');
    if (btn) TL.betting._lastBetBtn = btn;
  }, true);

  // Close panel on Escape (the bookmaker list handles its own Escape first)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      TL.betting.closePanel();
    }
  });

  // A tap anywhere outside the ▼ and its list closes the list.
  document.addEventListener('click', function (e) {
    var toggle = document.getElementById('v2bpBookieToggle');
    var listEl = document.getElementById('v2bpBookieList');
    if (!toggle || !listEl || listEl.hidden) return;
    if (!toggle.contains(e.target) && !listEl.contains(e.target)) TL.betting._setBookieListOpen(false);
  });

  // Swipe-down to close on mobile
  (function () {
    var panel = document.getElementById('v2BetPanel');
    if (!panel) return;
    var startY = 0;
    var currentY = 0;
    var swiping = false;

    panel.addEventListener('touchstart', function (e) {
      if (panel.scrollTop > 0) return;          // only when scrolled to top
      startY = e.touches[0].clientY;
      currentY = startY;
      swiping = true;
      panel.style.transition = 'none';
    }, { passive: true });

    panel.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      currentY = e.touches[0].clientY;
      var dy = currentY - startY;
      if (dy > 0) {
        panel.style.transform = 'translateY(' + dy + 'px)';
      }
    }, { passive: true });

    panel.addEventListener('touchend', function () {
      if (!swiping) return;
      swiping = false;
      var dy = currentY - startY;
      panel.style.transition = '';
      panel.style.transform = '';
      if (dy > 60) {
        TL.betting.closePanel();
      }
    });
  })();
})();
